
export default {
  data() {
    return {
      entityName: "",
      country: "India",
      business: {},
      selectRule: [(v) => !!v || "Please select a Country"],
      selectBusinessRule: [(v) => !!v || "Please select a Business Type"],
      selectNoOfLocationRule: [(v) => !!v || "Please select a Number"],
      valid: false,
      noOfLocation: [
        {
          id: "one",
          label: "1"
        },
        {
          id: "one-to-ten",
          label: "1-10"
        },
        {
          id: "ten-to-hundred",
          label: "10-100"
        },
        {
          id: "hundred-plus",
          label: "100+"
        }
      ]
    };
  },
  props: {
    businessProp: {
      type: Object,
      default: {}
    }
  },
  mounted() {
    this.business = JSON.parse(JSON.stringify(this.businessProp));
    this.$refs.createBusinessAccountForm.resetValidation();
  },
  methods: {
    validateForm() {
      this.valid = this.$refs.createBusinessAccountForm.validate();
    },

    submitCreatebusinessAccountDetails() {
      this.validateForm();
      if (this.valid) {
        this.$emit("submit-deails", this.business);
      }
    }
  }
};
